import { toast } from "react-toastify";
import axios from "axios";
import { getInvoicePrinter } from "@/react/Printer/print-utils.ts";
import { userFLow } from "@/shared/logger.ts";
import { loginUser } from "@/data/UserSignal.ts";
import { EscPrinter, EscPrinterLock } from "@/lib/entries";

let ip = 'localhost';

// let EscPrinter: typeof EscPrinterType;

export const openCashDrawer = async (): Promise<void> => {
  await EscPrinterLock.acquireAsync();
  userFLow("openCashDrawer in Payment", {
    username: loginUser()?.name,
  })
  const invoicePrinter = getInvoicePrinter();
  if (!invoicePrinter) return;
  toast('Open Cash Drawer ...', { autoClose: 200 });
  if (invoicePrinter.printerType === 'integrate') {
    await axios.post(`http://${ip}:5005/open-cash-drawer-sunmi`, {});
  } else {
    const printer = new EscPrinter(invoicePrinter);
    await printer.openCashDrawer();
    await printer.print();
  }
}